import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import ReCAPTCHA from 'react-google-recaptcha';

// This is the existing public reCAPTCHA site key; verification uses the backend secret.
const RECAPTCHA_SITE_KEY = '6LdG8BAdAAAAADBurhQ_3Vg8obMNaw3QErrPJ6FZ';

// Clear expired or rejected tokens; a browser token is never a reusable proof.
function Captcha({ input: { onChange }, meta: { touched, error } }) {
    const widget = useRef(null);
    const resetVersion = useSelector(state => state.appUI.captchaResetVersion);
    const lastReset = useRef(resetVersion);

    useEffect(() => {
        if (resetVersion !== lastReset.current && widget.current) {
            widget.current.reset();
            onChange(null);
        }
        lastReset.current = resetVersion;
    }, [resetVersion, onChange]);

    return (
        <div className="input-group has-validation">
            <ReCAPTCHA
                ref={widget}
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={onChange}
                onExpired={() => onChange(null)}
                onErrored={() => onChange(null)}
            />
            {touched && error && <p className="text-danger" role="alert">{error}</p>}
        </div>
    );
}

export default Captcha;
